









import { Component, Prop, Vue } from 'vue-property-decorator';
import { NavigationLink } from 'types/header';
import NavigationLinkSubmenu from './navigation-link-submenu.vue';

@Component({
	components: { NavigationLinkSubmenu }
})
export default class NavigationLinkDesktop extends Vue {
	@Prop()
	private link!: NavigationLink;

	get isSimpleLink(): boolean {
		return 'text' in this.link;
	}
}
